<template>
    <div>
        <div class="fixed top-96 left-96 h-full">
            <job-detail :job="active_job" :show-header="false" class="h-full"></job-detail>
        </div>

        <div class="w-full h-full bg-primary opacity-30 absolute inset-0"></div>

        <div v-show="nextStep" class="relative w-360 h-240">
            <tooltip :force-show=true
                     position="right"
                     wrapper-class="h-full flex items-center justify-end"
            >
                <div class="w-360 fixed top-192 left-96 z-top"
                     @click.prevent="handleNextStep"
                >
                    <stage-application v-if="firstStageApplication"
                                       :application="firstStageApplication"
                                       :job-has-selected="true"
                                       :locale="locale"
                                       :stage="firstStage"
                                       class="animate-[wiggle_1s_ease-in-out_infinite] cursor-pointer shadow-lg "
                    ></stage-application>
                </div>

                <template #tooltip>
                    <div class="p-16">
                        <popup-content :progress="70"
                                       :title="$t('free_trial.jobs.application_title')"
                                       :description="$t('free_trial.jobs.application_description')"
                                       icon="assignment-ind"
                        ></popup-content>

                        <simple-button class="mt-24"
                                       look="secondary"
                                       @click="nextStep = false">
                            {{ $t('general.back') }}
                        </simple-button>
                    </div>
                </template>
            </tooltip>
        </div>


        <div v-if="!nextStep" class="bg-white shadow-md mb-64 rounded-l ml-auto -mr-48 max-h-screen overflow-y-auto relative z-10 p-48 w-full max-w-640">
            <popup-content :description="$t('free_trial.jobs.fase_description')"
                           :progress="60"
                           :title="$t('free_trial.jobs.fase_title')"
                           icon="format-list-bulleted"
            ></popup-content>

            <pipeline-editor :job="active_job"
                             only-drag-and-drop
                             override-parent-class="pt-16"/>

            <div class="mt-48 flex justify-center space-x-20">
                <simple-button class="uppercase w-200"
                               look="secondary"
                               @click="handlePreviousClick">
                    {{ $t('general.back') }}
                </simple-button>


                <simple-button class="uppercase w-200"
                               display="secondary"
                               look="primary"
                               @click="nextStep = true">
                    {{ $t('jobs.next_step') }}
                </simple-button>
            </div>
        </div>
    </div>
</template>

<script>
import Job from '../../../models/Job';
import Stage from '../../../models/Stage';
import PipelineEditor from '../PipelineEditor.vue';
import SimpleButton from '../SimpleButton.vue';
import JobDetail from '../../JobDetail.vue';
import StageApplication from '../../StageApplication.vue';
import Tooltip from '../../navigation/Tooltip.vue';
import PopupContent from './PopupContent.vue';
import {mapState} from 'pinia';
import {useMainStore} from '../../../state/store';
import {useRepo} from 'pinia-orm';

export default {
    name: 'VacancyProcess',
    components: {PopupContent, Tooltip, StageApplication, JobDetail, PipelineEditor, SimpleButton},
    props: {
        active_job: Job,
    },
    data() {
        return {
            nextStep: false,
        };
    },
    computed: {
        ...mapState(useMainStore, ['locale']),
        firstStage() {
            return useRepo(Stage)
                .with('applications', (q) => {
                    q.with('stage', (q2) => {
                        q2.with('job');
                    });
                })
                .where('job_id', this.active_job.id)
                .orderBy('order')
                .first();
        },
        firstStageApplication() {
            if (this.firstStage && this.firstStage.applications) {
                return this.firstStage.applications[0];
            }
        },
    },
    methods: {
        handlePreviousClick() {
            this.$emit('setApplication', null);

            return this.$emit('previous');
        },
        handleNextStep() {
            this.$emit('setApplication', this.firstStageApplication);

            return this.$emit('next');
        },
    },
};
</script>
